export default "__VITE_ASSET__VNcB5xPE__"